import { Button } from '@chakra-ui/react'
import { ChangeEvent, FC, useRef, useState } from 'react'

import useParametrizationConfigPurchase from '@hook/parametrization/use-config-purchase'

const ActionCronogramaUpload: FC = () => {
  const { uploadCronogramaCompra } = useParametrizationConfigPurchase()
  const inputFileRef = useRef<HTMLInputElement>(null)
  const [isUploading, setIsUploading] = useState(false)

  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    // Reset the input value to allow selecting the same file again
    event.target.value = ''
    if (!file || isUploading || !uploadCronogramaCompra) return
    setIsUploading(true)
    try {
      await uploadCronogramaCompra(file)
    } finally {
      setIsUploading(false)
    }
  }

  const onButtonClick = () => {
    // Bloqueia duplo envio enquanto o upload anterior não terminou
    if (isUploading) return
    inputFileRef.current?.click()
  }

  return (
    <>
      <input
        type="file"
        accept=".csv"
        ref={inputFileRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
      <Button
        size="xs"
        fontSize="12px"
        letterSpacing=".2px"
        p="4px 6px"
        bg="gray.200"
        fontWeight="400"
        isLoading={isUploading}
        isDisabled={isUploading}
        spinnerPlacement="start"
        _hover={{ bgColor: 'gray.100' }}
        _active={{ bgColor: 'gray.100' }}
        onClick={onButtonClick}
      >
        Importar Cronograma
      </Button>
    </>
  )
}

export default ActionCronogramaUpload
